
import { Vue, Component } from 'vue-property-decorator';
import { Form } from 'element-ui';

@Component
export default class formMixin extends Vue {
  public form: any = {
  };

  public loading: boolean = false;

  public $refs!: {
    form: Form,
  };

  private rules: { [key: string]: Array<object> } = {
    videoTitle: [
      { required: true, message: '视频名称不能为空' },
    ],
    videoType: [
      { required: true, message: '类别不能为空' },
    ],
    videoDescription: [
      { required: true, message: '视频简介不能为空' },
    ],
    videoPath: [
      { required: true, message: '地址不能为空' },
    ],
    seq: [
      { required: true, message: '排序不能为空' },
    ],
  };

  /* eslint-disable class-methods-use-this */
  reset(close: boolean, refrsh: boolean) {}

  /**
   * @author liangyongmou
   * @desc 重置表单
   * @param 空
   */
  resetForm() {
    this.$refs.form.resetFields();
  }
}
